import { type UseQueryOptions, useQuery } from '@tanstack/react-query'

import { useGoogleMaps } from './useGoogleMaps'

export const useGoogleMapsGeocodeKey = 'google-maps/geocode'

export function useGoogleGeocode<TData>(
  request: google.maps.GeocoderRequest,
  options?: Omit<
    UseQueryOptions<google.maps.GeocoderResult[], unknown, TData>,
    'queryKey' | 'queryFn'
  >,
) {
  const { geocode, isReady } = useGoogleMaps()

  return useQuery({
    queryKey: [useGoogleMapsGeocodeKey, request, isReady],
    queryFn: async () => geocode(request),
    ...options,
  })
}
